import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'

import Accordion from 'src/components/Organisms/Accordion/Accordion'
import { ExternalLink } from 'src/components/Core/Styles/Link'
import Font from 'src/components/Core/Typography/Font/Font'
import Label from 'src/components/Atoms/Label/Label'
import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import { CORP_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import CountryOfResidency from './Table/CountryOfResidency'

export const clientDocumentationLink = <ExternalLink href='https://www.sucdenfinancial.com/en/client-documentation-and-disclosures/' />
export const controllingFormTemplate = <ExternalLink href='https://www.sucdenfinancial.com/media/hunjfcj5/sfl-controlling-person-form.pdf' />

const AccordionRegulations = (
  <Accordion
    key='regulationsOECD'
    title={t('onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.accordionRegulations.title')}
    margin='0 0 24px 0'
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.accordionRegulations.content'} components={{ clientDocumentationLink }}/>
  </Accordion>
)

const EntityTypeText = (
  <Font
    tag='h4'
    key='EntityTypeText'
    bold
    ellipsis={false}
    margin='0 0 8px 0'
  >
    {t('onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.entityType')}
  </Font>
)

const AccountHolderStatusLabel = (
  <Label
    key='AccountHolderStatusLabel'
    removeEllipsis
    label={t('onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.accountHolderStatus')}
    required
  />
)

const ConstitutesControllingPersonText = () => (
  <Font
    ellipsis={false}
    margin='0 0 40px 5%'
  >
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.constitutesControllingPerson'} components={{ clientDocumentationLink }}/>
  </Font>
)

const AccordionActiveNFE = (
  <Accordion
    key='AccordionActiveNFE'
    title={t('onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.accordionActiveNFE.title')}
    margin='24px 0 24px 0'
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.accordionActiveNFE.content'} components={{ clientDocumentationLink }}/>
  </Accordion>
)

const PleaseAddCountryText = (
  <Font
    key='PleaseAddCountryText'
    ellipsis={false}
  >
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.pleaseAddCountryOfResidence'} components={{ requiredMark: <RequiredMark />  }} />
  </Font>
)

export const NonUSpersonsText = (
  <Font
    key='NonUSpersonsText'
    ellipsis={false}
    margin='0 0 24px 4%'
  >
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.nonUSpersons'} components={{ clientDocumentationLink }} />
  </Font>
)

const ControllingPersonsTemplate = () => (
  <Font
    key='ControllingPersonsTemplate'
    ellipsis={false}
    margin='24px 0 40px 5%'
  >
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.visualOnly.controllingPersonsTemplate'} components={{ controllingFormTemplate }} />
  </Font>
)

const config = utils.injectTranslation({
  id: 'TaxResidencyForm',
  path: 'onboarding.forms.CorporateAccount.TaxResidencyForm.inputs',
  keysToRemove: ['visual', 'documentID', 'country'],
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'accordion',
          visualComponent: AccordionRegulations
        },
        {
          componentType: '',
          visualComponent: EntityTypeText
        },
        {
          componentType: 'label',
          visualComponent: AccountHolderStatusLabel
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'anInvestmentEntity',
            value: 'anInvestmentEntity',
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.anInvestmentEntity'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'inputMultipleNumbers',
          props: {
            name: 'giinNo',
            numberFormat: '000000-00000-00-000',
            minHeight: '0',
            wrapperPadding: '0 0 0 5%',
            removeLabelEllipsis: true,
            isAlphaNumeric: true,
            lowerToUpperCase: true,
            required: true,
          },
          secondaryName: 'anInvestmentEntity-inputs'
        },
        {
          componentType: 'input',
          props: {
            name: 'controllingPersonsForm',
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '16px 0 0 5%',
            inputMargin: '8px 0 8px 0',
            buttonMargin: '8px 0 0 -8px',
            groupLabelMargin: '0 0 16px 0',
            width: '95%',
            // @ts-ignore:next-line
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.groupLabel'} components={{ clientDocumentationLink, requiredMark: <RequiredMark /> }}/>,
            buttonLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.buttonLabel'),
            labelAsTextInput: true,
            labelAsTextInputLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelAsTextInputLabel'),
            labelAsTextInputPlaceholder: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelAsTextinputPlaceholder'),
            labelForInputFile: <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelForInputFile'} />,
            fetchOptions: {
              requestConfig: {
                url: CORP_SEND_FILE_URL
              }
            },
            step: '7',
            name: 'controllingPersonsForm',
            itemKey: 'anInvestmentEntity-fileInputs',
            fontSize: '14px',
            ...props
          }),
          visualName: 'anInvestmentEntity-fileInput'
        },
        {
          componentType: '',
          custom: () => ControllingPersonsTemplate(),
          visualName: 'anInvestmentEntity-controllingPersonsTemplate'
        },
        {
          componentType: '',
          custom: () => ConstitutesControllingPersonText(),
          visualName: 'anInvestmentEntity-controllingPersonText'
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'otherInvestment',
            value: 'otherInvestment',
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.otherInvestment'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'inputMultipleNumbers',
          props: {
            name: 'giinNo',
            numberFormat: '000000-00000-00-000',
            minHeight: '0',
            wrapperPadding: '0 0 0 5%',
            removeLabelEllipsis: true,
            isAlphaNumeric: true,
            lowerToUpperCase: true,
            required: true,
          },
          secondaryName: 'otherInvestment-inputs'
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'financialInstitution',
            value: 'financialInstitution',
            //@ts-ignore 
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.financialInstitution'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'inputMultipleNumbers',
          props: {
            name: 'giinNo',
            numberFormat: '000000-00000-00-000',
            minHeight: '0',
            wrapperPadding: '0 0 0 5%',
            removeLabelEllipsis: true,
            isAlphaNumeric: true,
            lowerToUpperCase: true,
            required: true,
          },
          secondaryName: 'financialInstitution-inputs'
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'activeNFEcorporation',
            value: 'activeNFEcorporation',
            //@ts-ignore 
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.activeNFEcorporation'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'activeNFEgovernment',
            value: 'activeNFEgovernment',
            //@ts-ignore 
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.activeNFEgovernment'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'activeNFEinternational',
            value: 'activeNFEinternational',
            //@ts-ignore 
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.activeNFEinternational'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'activeNFEother',
            value: 'activeNFEother',
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.activeNFEother'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'radioButton',
          props: {
            name: 'eAccountHoldersStatus',
            id: 'passiveNFE',
            value: 'passiveNFE',
            label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.passiveNFE'),
            display: 'inline',
            minWidth: '24px',
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'controllingPersonsForm',
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '16px 0 0 5%',
            inputMargin: '8px 0 8px 0',
            buttonMargin: '8px 0 0 -8px',
            groupLabelMargin: '0 0 16px 0',
            width: '95%',
            // @ts-ignore:next-line
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.groupLabel'} components={{ clientDocumentationLink, controllingFormTemplate, requiredMark: <RequiredMark /> }}/>,
            buttonLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.buttonLabel'),
            labelAsTextInput: true,
            labelAsTextInputLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelAsTextInputLabel'),
            labelAsTextInputPlaceholder: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelAsTextinputPlaceholder'),
            labelForInputFile: <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.files.controllingPersons.labelForInputFile'} />,
            fetchOptions: {
              requestConfig: {
                url: CORP_SEND_FILE_URL
              }
            },
            step: '7',
            name: 'controllingPersonsForm',
            itemKey: 'passiveNFE-fileInputs',
            fontSize: '14px',
            ...props
          }),
          visualName: 'passiveNFE-fileInput'
        },
        {
          componentType: '',
          custom: () => ControllingPersonsTemplate(),
          visualName: 'passiveNFE-controllingPersonsTemplate'
        },
        {
          componentType: '',
          custom: () => ConstitutesControllingPersonText(),
          visualName: 'passiveNFE-controllingPersonText'
        },
        {
          componentType: 'accordion',
          visualComponent: AccordionActiveNFE
        },
        {
          componentType: '',
          visualComponent: PleaseAddCountryText
        },
        {
          componentType: '',
          props: {
            name: 'countryOfResidences'
          },
          custom: props => CountryOfResidency({...props})
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isaUSPerson',
            minHeight: '0',
            margin: '16px 0 16px 0',
            dataList: [
              {
                id: 'isaUSPerson2',
                label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.USPerson'),
                value: 'true',
              },
              {
                id: 'isaUSPerson1',
                label: t('onboarding.forms.CorporateAccount.TaxResidencyForm.inputs.nonUSperson'),
                value: 'false',
              },
            ],
            required: true
          },
        },
        {
          componentType: '',
          visualComponent: NonUSpersonsText,
          visualName: 'nonUsPersonText'
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isUSProducts',
            margin: '0 0 8px 4%',
            marginBottom: '0',
            minHeight: '0',
            dataList: [
              {
                id: 'isUSProducts1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isUSProducts2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'formW8BEN',
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '0 0 0 8%',
            inputMargin: '0 0 24px 0',
            width: '92%',
            inputLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.w8ben.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: CORP_SEND_FILE_URL
              }
            },
            step: '7',
            name: 'formW8BEN',
            itemKey: 'w8ben',
            ...props
          }),
          visualName: 'w8ben-fileInput'
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isNonUSPersonsAccountOpen',
            translationValues: {
              personType: 'non-US',
              other: 'the relevant ',
              formType: 'W-8BEN-E'
            },
            margin: '0 0 0 4%',
            marginBottom: '0',
            dataList: [
              {
                id: 'isNonUSPersonsAccountOpen1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isNonUSPersonsAccountOpen2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
          },
          secondaryName: 'nonUS-isNonUSPersonsAccountOpen'
        },
        {
          componentType: 'input',
          props: {
            name: 'formW9',
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '0 0 0 4%',
            inputMargin: '8px 0 24px 0',
            width: '96%',
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.files.w9.groupLabel'} components={{ clientDocumentationLink }}/>,
            inputLabel: t('onboarding.forms.CorporateAccount.TaxResidencyForm.files.w9.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: CORP_SEND_FILE_URL
              }
            },
            step: '7',
            name: 'formW9',
            itemKey: 'w9-fileInput',
            ...props
          }),
          visualName: 'w9-fileInput'
        },
      ]
    },
  ],
})

export default config
